import { gql } from '@apollo/client';

export const ALL_LOCATIONS = gql`
  query AllLocations {
    locations: getLocations {
      id
      name
    }
  }
`;
